import { ref, onUnmounted } from 'vue'

function createSSEParser(onMessage) {
  let buffer = ''

  return function parse(chunk) {
    console.log('step1',chunk)
    buffer += chunk
    console.log('step2',buffer)
    let index
    //最后结束时data:,没有"\n\n""
    while ((index = buffer.indexOf('\n\n')) !== -1) {
      const rawEvent = buffer.slice(0, index)
      console.log('step3',rawEvent)
      buffer = buffer.slice(index + 2)
      console.log('step4',buffer)
      rawEvent
        .split('\n')
        .filter(line => line.startsWith('data:'))
        .forEach(line => {
          const data = line.replace(/^data:\s?/, '')
          onMessage && onMessage(data)
        })
    }
  }
}

export function useSSEByXHR() {
  const xhr = ref(null)
  const isStreaming = ref(false)

  function startSSE(url, body, options = {}) {
    stopSSE()

    isStreaming.value = true
    const _xhr = new XMLHttpRequest()
    xhr.value = _xhr

    _xhr.open('POST', url, true)
    _xhr.setRequestHeader('Content-Type', 'application/json')
    _xhr.setRequestHeader('Accept', 'text/event-stream')

    let lastIndex = 0
    const parse = createSSEParser(options.onMessage)

    _xhr.onprogress = function () {
       console.log( '_xhr.responseText',_xhr.responseText)
      const chunk = _xhr.responseText.slice(lastIndex)
      lastIndex = _xhr.responseText.length

      parse(chunk)
  
    }

    _xhr.onerror = function () {
      isStreaming.value = false
      options.onError && options.onError(new Error('XHR stream error'))
    }

    _xhr.onload = function () {
      isStreaming.value = false
      options.onComplete && options.onComplete()
    }

    _xhr.send(JSON.stringify(body))
  }

  function stopSSE() {
    if (xhr.value) {
      xhr.value.abort()
      xhr.value = null
      isStreaming.value = false
    }
  }

  onUnmounted(stopSSE)

  return {
    startSSE,
    stopSSE,
    isStreaming
  }
}
